// Titres et descriptions SEO validés par le client (juin 2026).
// Les mentions "console de commande", "portée 300 m" et "mallette incluse" ont été retirées :
// aucun kit ne les contient (contenu réel : bracelets + 1 contrôleur au choix + marquage 1 couleur + lien NFC offerts).
export const SITE = 'https://www.party-led.com';

export const PRODUCT_SEO = {
  'party-led-kit-50-personnes': {
    title: 'Kit 50 bracelets LED — 990 € HT livré prêt à l\'emploi | Party LED',
    description: "Le kit d'entrée pour un anniversaire, un dîner privé ou une petite réception : 50 bracelets synchronisés, contrôleur au choix, marquage 1 couleur et lien NFC offerts. 990 € HT.",
  },
  'party-led-kit-100-personnes': {
    title: 'Kit 100 bracelets LED — 1 190 € HT pour mariage et soirée | Party LED',
    description: "100 bracelets LED synchronisés pour un mariage ou une soirée d'entreprise : ouverture de bal, entrée des mariés, photo de groupe lumineuse. 1 190 € HT, livré.",
  },
  'party-led-kit-200-personnes': {
    title: 'Kit 200 bracelets LED — 1 550 € HT contrôleur inclus | Party LED',
    description: '200 bracelets LED pilotés depuis le contrôleur de votre choix : mini télécommande, application mobile ou ordinateur. Grands mariages, concerts et festivals. 1 550 € HT.',
  },
  'party-led-kit-300-personnes': {
    title: 'Kit 300 bracelets LED — 1 900 € HT pour gala et séminaire | Party LED',
    description: '300 bracelets LED synchronisés pour un gala, un séminaire ou un lancement de produit. Toute la salle passe aux couleurs de la marque. 1 900 € HT, livré.',
  },
  'party-led-kit-400-personnes': {
    title: 'Kit 400 bracelets LED — 2 300 € HT pour soirée étudiante | Party LED',
    description: '400 bracelets LED pour une soirée étudiante, un bal de promo ou une grande fête associative. Effets pilotés en direct depuis la régie. 2 300 € HT, livré.',
  },
  'party-led-kit-500-personnes': {
    title: 'Kit 500 bracelets LED — 2 490 € HT pour concert | Party LED',
    description: '500 bracelets LED synchronisés pour une salle de concert ou un festival : vagues de couleur sur toute la foule, chaque titre a sa teinte. 2 490 € HT, livré.',
  },
  'party-led-kit-600-personnes': {
    title: 'Kit 600 bracelets LED — 2 790 € HT pour événement corporate | Party LED',
    description: "600 bracelets LED pour une convention, une soirée de fin d'année ou un team building. Marquage aux couleurs de l'entreprise offert. 2 790 € HT, livré.",
  },
  'party-led-kit-700-personnes': {
    title: 'Kit 700 bracelets LED — 3 190 € HT pour tribune sportive | Party LED',
    description: '700 bracelets LED pour un club de sport : tribunes aux couleurs du club, éclair à chaque but, bracelets réutilisables toute la saison. 3 190 € HT, livré.',
  },
  'party-led-kit-800-personnes': {
    title: 'Kit 800 bracelets LED — 3 490 € HT pour festival | Party LED',
    description: '800 bracelets LED synchronisés pour un festival ou un grand rassemblement, pilotés en direct depuis un ordinateur ou un smartphone. 3 490 € HT, livré.',
  },
  'party-led-kit-900-personnes': {
    title: 'Kit 900 bracelets LED — 3 690 € HT pour grand événement | Party LED',
    description: "900 bracelets LED pour un grand événement public : effets pilotés en direct, images spectaculaires pour l'aftermovie. 3 690 € HT, livré.",
  },
  'party-led-kit-1000-personnes': {
    title: 'Kit 1 000 bracelets LED — 3 990 € HT, le plus grand kit | Party LED',
    description: '1 000 bracelets LED synchronisés, notre plus grand kit prêt à l\'emploi : stade, festival, grand rassemblement. Au-delà, demandez un devis. 3 990 € HT.',
  },
};

// Titres et descriptions SEO traduits (EN/AR) — orientés référencement local Dubaï / UAE.
export const PRODUCT_SEO_I18N = {
  'party-led-kit-50-personnes': {
    en: { title: '50 LED Wristbands Kit — Birthdays & Private Parties | Party LED', description: 'Entry kit for a birthday, private dinner or small reception in Dubai: 50 synchronised wristbands, your choice of controller, 1-colour branding and NFC link included.' },
    ar: { title: 'طقم 50 سوار LED — أعياد ميلاد وحفلات خاصة | Party LED', description: 'طقم مبدئي لعيد ميلاد أو حفل خاص صغير في دبي: 50 سواراً متزامناً، ووحدة تحكم من اختيارك، وطباعة بلون واحد ورابط NFC مجاناً.' },
  },
  'party-led-kit-100-personnes': {
    en: { title: '100 LED Wristbands Kit — Weddings & Corporate Nights | Party LED', description: '100 synchronised LED wristbands for a wedding or corporate night in Dubai: first dance, grand entrance, glowing group photo. Controller, branding and NFC included.' },
    ar: { title: 'طقم 100 سوار LED — أعراس وحفلات الشركات | Party LED', description: '100 سوار LED متزامن لحفل زفاف أو مناسبة شركة في دبي: افتتاح الرقص والدخول الكبير وصورة جماعية مضيئة. تشمل وحدة التحكم والطباعة ورابط NFC.' },
  },
  'party-led-kit-200-personnes': {
    en: { title: '200 LED Wristbands Kit — Concerts & Festivals | Party LED', description: '200 LED wristbands driven from your chosen controller: mini remote, mobile app or computer. For large weddings, concerts and festivals across the UAE.' },
    ar: { title: 'طقم 200 سوار LED — حفلات موسيقية ومهرجانات | Party LED', description: '200 سوار LED يتم التحكم بها من وحدة اختيارك: ريموت صغير أو تطبيق جوال أو كمبيوتر. لأعراس كبيرة وحفلات ومهرجانات في الإمارات.' },
  },
  'party-led-kit-300-personnes': {
    en: { title: '300 LED Wristbands Kit — Galas & Conferences | Party LED', description: '300 synchronised LED wristbands for a gala, conference or product launch in Dubai. The whole room turns to your brand colours.' },
    ar: { title: 'طقم 300 سوار LED — حفلات غالا ومؤتمرات | Party LED', description: '300 سوار LED متزامن لحفل غالا أو مؤتمر أو إطلاق منتج في دبي. تتحوّل القاعة بالكامل إلى ألوان علامتك التجارية.' },
  },
  'party-led-kit-400-personnes': {
    en: { title: '400 LED Wristbands Kit — University & Big Parties | Party LED', description: '400 LED wristbands for a university night, prom or large community party. Effects driven live from the booth, anywhere in the UAE.' },
    ar: { title: 'طقم 400 سوار LED — حفلات جامعية وكبيرة | Party LED', description: '400 سوار LED لحفلة جامعية أو حفل تخرّج أو مناسبة كبيرة. يتم التحكم بالمؤثرات مباشرة من غرفة التحكم في أي مكان بالإمارات.' },
  },
  'party-led-kit-500-personnes': {
    en: { title: '500 LED Wristbands Kit — Concerts & Shows | Party LED', description: '500 synchronised LED wristbands for a concert hall or festival: waves of colour across the whole crowd, a hue for every track.' },
    ar: { title: 'طقم 500 سوار LED — حفلات موسيقية وعروض | Party LED', description: '500 سوار LED متزامن لقاعة حفلات أو مهرجان: موجات من الألوان تعمّ الجمهور، ولكل أغنية لونها.' },
  },
  'party-led-kit-600-personnes': {
    en: { title: '600 LED Wristbands Kit — Corporate Events | Party LED', description: '600 LED wristbands for a convention, year-end party or team building. Branding in your company colours included.' },
    ar: { title: 'طقم 600 سوار LED — فعاليات الشركات | Party LED', description: '600 سوار LED لمؤتمر أو حفل نهاية العام أو بناء الفريق. تشمل الطباعة بألوان شركتك.' },
  },
  'party-led-kit-700-personnes': {
    en: { title: '700 LED Wristbands Kit — Sports Stands | Party LED', description: '700 LED wristbands for a sports club: stands in the club colours, a flash at every goal, reusable all season long.' },
    ar: { title: 'طقم 700 سوار LED — مدرجات رياضية | Party LED', description: '700 سوار LED لنادٍ رياضي: مدرجات بألوان النادي، ووميض مع كل هدف، قابلة لإعادة الاستخدام طوال الموسم.' },
  },
  'party-led-kit-800-personnes': {
    en: { title: '800 LED Wristbands Kit — Festivals | Party LED', description: '800 synchronised LED wristbands for a festival or large gathering, driven live from a computer or smartphone.' },
    ar: { title: 'طقم 800 سوار LED — مهرجانات | Party LED', description: '800 سوار LED متزامن لمهرجان أو تجمّع كبير، يتم التحكم به مباشرة من كمبيوتر أو هاتف ذكي.' },
  },
  'party-led-kit-900-personnes': {
    en: { title: '900 LED Wristbands Kit — Large Events | Party LED', description: '900 LED wristbands for a large public event: live-driven effects and spectacular footage for the aftermovie.' },
    ar: { title: 'طقم 900 سوار LED — فعاليات كبرى | Party LED', description: '900 سوار LED لفعالية عامة كبيرة: مؤثرات مباشرة ولقطات مذهلة لفيديو ما بعد الحدث.' },
  },
  'party-led-kit-1000-personnes': {
    en: { title: '1,000 LED Wristbands Kit — Our Largest Kit | Party LED', description: '1,000 synchronised LED wristbands, our largest ready-to-use kit: stadium, festival, major gathering. Need more? Request a quote.' },
    ar: { title: 'طقم 1000 سوار LED — أكبر أطقمنا | Party LED', description: '1000 سوار LED متزامن، أكبر طقم جاهز للاستخدام لدينا: ملعب أو مهرجان أو تجمّع كبير. تحتاج أكثر؟ اطلب عرض سعر.' },
  },
};

// Renvoie {title, description} selon la langue, ou null (fallback générique géré par la page).
export const productSeoFor = (slug, lang) => {
  if (lang === 'fr') return PRODUCT_SEO[slug] || null;
  return PRODUCT_SEO_I18N[slug]?.[lang] || null;
};


export const PAGE_SEO = {
  '/': {
    description: "Kits de bracelets LED synchronisés pour mariages, festivals et soirées d'entreprise. De 50 à 1 000 personnes, à partir de 990 € HT, livrés prêts à l'emploi.",
  },
  '/catalogue': {
    title: 'Nos kits bracelets LED, de 50 à 1 000 personnes | Party LED',
    description: 'Onze kits prêts à l\'emploi, de 990 € à 3 990 € HT. Choisissez selon le nombre d\'invités : bracelets, contrôleur au choix, marquage 1 couleur et lien NFC dans chaque kit.',
  },
  '/blog': {
    title: 'Réussir son animation lumineuse — le blog | Party LED',
    description: 'Conseils pour préparer une animation en bracelets LED : quel kit choisir, à quel moment de la soirée le lancer, comment piloter les effets.',
  },
  '/contact': {
    title: 'Contact et devis — France & Dubai | Party LED',
    description: 'Une question, un événement de plus de 1 000 personnes, un besoin sur mesure ? Écrivez-nous, réponse sous 24 h. Bureaux en France et à Dubai.',
  },
};

// Textes français validés : on ne les impose qu'en français, les autres langues gardent leurs traductions.
export const seoFor = (path, lang, fallback = {}) => (lang === 'fr' ? { ...fallback, ...(PAGE_SEO[path] || {}) } : fallback);
